import { NgModule } from '@angular/core';
import { PlaylistComponent } from './playlist.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [PlaylistComponent],
  imports: [SharedModule],
})
export class PlaylistModule {}
